import { useEffect, useState } from "react";
import "./valentinesCountdown.scss";

const ValentinesCountdown = () => {
  // Month is 0-based → 1 = February
  const SALE_START = new Date(2026, 1, 7, 0, 0, 0).getTime();
  const SALE_END = new Date(2026, 1, 14, 23, 59, 59).getTime();

  const [state, setState] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
    phase: "before", // before | live | ended
    label: "Sale Starts In",
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = Date.now();

      let target;
      let phase;
      let label;

      if (now < SALE_START) {
        target = SALE_START;
        phase = "before";
        label = "Sale Starts In";
      } else if (now >= SALE_START && now <= SALE_END) {
        target = SALE_END;
        phase = "live";
        label = "Sale Ends In";
      } else {
        setState((prev) => ({ ...prev, phase: "ended" }));
        return;
      }

      const distance = target - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setState({
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
        phase,
        label,
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`valentines-countdown ${state.phase}`}>
      <div className="countdown-banner">
        <div className="hearts-bg">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="heart">
              ♥
            </div>
          ))}
        </div>

        <div className="banner-content">
          {/* LEFT CONTENT */}
          {state.phase === "ended" ? (
            <div className="left-content">
              <h1 className="main-title">Sale Has Ended 💔</h1>
              <p className="subtitle">Thank you for the love!</p>
            </div>
          ) : (
            <div className="left-content">
              <div className="pre-title">Limited Time Only</div>
              <h1 className="main-title">
                Valentine's Day Sale {state.phase === "live" && " is Live"}
              </h1>
              <p className="subtitle">
                {state.label}
                {state.phase === "live" && " 🔥"}
              </p>
            </div>
          )}

          {/* COUNTDOWN */}
          {state.phase !== "ended" && (
            <div className="countdown-container">
              <div className="time-unit">
                <div className="time-value">{state.days}</div>
                <div className="time-label">Days</div>
              </div>
              <div className="separator">:</div>

              <div className="time-unit">
                <div className="time-value">{state.hours}</div>
                <div className="time-label">Hours</div>
              </div>
              <div className="separator">:</div>

              <div className="time-unit">
                <div className="time-value">{state.minutes}</div>
                <div className="time-label">Min</div>
              </div>
              <div className="separator">:</div>

              <div className="time-unit">
                <div className="time-value">{state.seconds}</div>
                <div className="time-label">Sec</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ValentinesCountdown;
